import produce from "immer";
import { ReceiptActions } from ".";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { defaultReceiptReport, defaultReceiptReportState } from "./default";
import { CLEAR_RECIEPT_REPORT_STATE, CLEAR_RECIEPT_REPORT, FETCH_RECIEPT_REPORT_LIST_FAILED, FETCH_RECIEPT_REPORT_LIST_PROGRESS, FETCH_RECIEPT_REPORT_LIST_SUCCESS } from "./receiptAction";









export const receiptReportReducer = (
  state: IStoreState["recieptReport"] = defaultReceiptReportState,
  action: ReceiptActions
) => {
    switch (action.type) {
        case FETCH_RECIEPT_REPORT_LIST_PROGRESS: {
             const newState = produce(state, (draftState) => {
               draftState.recieptReport.loading = LoadState.InProgress;
               draftState.list.data = [];
               draftState.recieptReport.data = defaultReceiptReport;
               draftState.list.totalRecords = 0;
             });
             return newState;
           }
           case FETCH_RECIEPT_REPORT_LIST_SUCCESS: {
             const { data,  singleReport, totalRecords, totalPaidFee } = action.payload;
             const newState = produce(state, (draftState) => {
               draftState.recieptReport.loading = LoadState.Loaded;
               draftState.recieptReport.data = singleReport;
               draftState.list.data = data;
               draftState.amount.totalPaidFee = totalPaidFee;
               draftState.list.totalRecords = totalRecords;

             });
             return newState;
           }
        case FETCH_RECIEPT_REPORT_LIST_FAILED: {
             const newState = produce(state, (draftState) => {
               draftState.recieptReport.loading = LoadState.Failed;
               draftState.list.data = [];
               draftState.recieptReport.data = defaultReceiptReport;
               draftState.list.totalRecords = 0;


             });
             return newState;
           }
           case CLEAR_RECIEPT_REPORT_STATE: {
            return defaultReceiptReportState;
           }
          //  case CLEAR_RECIEPT_REPORT: {
          //   return defaultReceiptReportState;
          //  }
           default: {
            return state;
          }
      }
    
};